import { requestWithToken } from '../utilities/request';
import { FieldTreeService } from './FieldTrees';
import { API } from '../utilities/constants';
import _dialogLoader from '../utilities/dialogLoader';
import {
  CanselDialog,
  ApprovalDialog,
  CompleteDialog,
} from '../components/modals/LaborSafetyDialog';
import { FieldTreeFormStore } from '../utilities/LaborSafetyNotify';

/**
 * @description 労安帳票画面で共有して使う通信関数
 */

const path = '/api/private/fields';

/**
 * @description Excelファイルをダウンロード
 */
export const onExcel = e => {
  const target = e.target;
  const field_tree = FieldTreeFormStore.getStore();

  if (field_tree) {
    if (!field_tree.report_xlsx_file_name) {
      return alert('ファイルがありません。');
    }

    let link = document.createElement('a');

    link.download = `${API.endpoint}/reports/${
      field_tree.report_xlsx_file_name
    }`;

    target.parentElement.appendChild(link);

    link.click(); // downloadさせる
  } else {
    alert('取得に失敗しました。');
  }
};

/**
 * @description PDFファイルをダウンロード
 */
export const onPDF = e => {
  const target = e.target;
  const field_tree = FieldTreeFormStore.getStore();

  if (field_tree) {
    if (!field_tree.report_xlsx_file_name) {
      return alert('ファイルがありません。');
    }

    let link = document.createElement('a');

    link.download = `${API.endpoint}/reports/${
      field_tree.report_pdf_file_name
    }`;

    link.onclick = () => alert('Clicked now!');

    target.parentElement.appendChild(link);

    link.click(); // downloadさせる
  } else {
    alert('取得に失敗しました。');
  }
};

/**
 * @description 帳票を承認する
 */
export const onApproval = ({ form_code = 4 }) => {
  const comment_user_id = +window.localStorage.getItem('user_id');
  let params = { form_code };

  _dialogLoader.show(ApprovalDialog, {
    callbacks: {
      getComments: comment => {
        if (!comment) {
          return delete params.field_tree_form_status_comments;
        }
        params.field_tree_form_status_comments = [{ comment, comment_user_id }];
      },
      onApproval: async () => {
        const field_tree = FieldTreeFormStore.getStore();

        if (!field_tree) {
          alert('承認に失敗しました。');
          _dialogLoader.close();
          return;
        }

        params[`approval_flag_${field_tree.nest_no}`] = 1; // 承認済みにする

        const data = await FieldTreeService.updateFormStatus(
          field_tree.field_id,
          field_tree.field_tree_id,
          params
        );

        if (data && data.result) {
          alert('承認しました。');
          FieldTreeFormStore.setStore(
            data.data.entities.field_tree_form_status
          );
        } else {
          alert('承認に失敗しました。');
        }

        _dialogLoader.close();
      },
    },
  });
};

export const onCansel = ({ form_code = 4 }) => {
  const comment_user_id = +window.localStorage.getItem('user_id');
  let params = { form_code };

  _dialogLoader.show(CanselDialog, {
    callbacks: {
      getComments: comment => {
        if (!comment) {
          return delete params.field_tree_form_status_comments;
        }
        params.field_tree_form_status_comments = [{ comment, comment_user_id }];
      },
      onCansel: async () => {
        const field_tree = FieldTreeFormStore.getStore();

        if (!field_tree) {
          alert('否認に失敗しました。');
          _dialogLoader.close();
          return;
        }

        params[`approval_flag_${field_tree.nest_no}`] = 2; // 否認にする

        const data = FieldTreeService.updateFormStatus(
          field_tree.field_id,
          field_tree.field_tree_id,
          params
        );

        if (data && data.result) {
          alert('否認しました。');
          FieldTreeFormStore.setStore(
            data.data.entities.field_tree_form_status
          );
        } else {
          alert('否認に失敗しました。');
        }

        _dialogLoader.close();
      },
    },
  });
};

export const onCreateComplete = ({ form_code = 2 }) => {
  const comment_user_id = +window.localStorage.getItem('user_id');
  let params = { form_code };

  _dialogLoader.show(CompleteDialog, {
    callbacks: {
      getComments: comment => {
        if (!comment) {
          return delete params.field_tree_form_status_comments;
        }
        params.field_tree_form_status_comments = [{ comment, comment_user_id }];
      },
      onComplete: () => {
        alert('完了しました。');
        _dialogLoader.close();
      },
    },
  });
};

/**
 * @description ステータスについているコメントを削除する
 */
export const deleteStatusComment = (field_id, field_tree_id, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(
      `/${field_id}/field_trees/${field_tree_id}` +
        '/field_tree_form_status/' +
        'field_tree_form_status_comments/list'
    ),
    params: {
      field_tree_form_status_comment_ids: [id],
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/LaborSafety.js